import Card from "./Card";
import React from "react";

function Team() {
  const items = [
    {
      id: 2,
      name: "Kristián Koštál",
      role: "Master Mind",
      picture:
        "./Kiko_Ranger.jpg",
      text: "Múdry čarodej bojujúci za stranu dobra proti temným nepriateľským silám na Zemi.",
      photo: "./Kiko.jpg"
    },
    {
      id: 3,
      name: "Zuzana Wlachovská",
      role: "Scrub Master",
      picture:
      "./Zuzka_Ranger.png",
      text: "Prisahám, ja viem všetko o Blockchaine verte mi.",
      photo: "./Zuzka.jpg"
    },
    {
      id: 4,
      name: "Nina Masaryková",
      role: "Jack Of All Trades",
      picture:
        "Nina_Ranger.jpg",
      text: "Daj mi alpu, okenu a tri rožky s treskou.",
      photo: "./Nina.jpg"
    },
    {
      id: 5,
      name: "Marek Štrba",
      role: "Head Scribe",
      picture:
        "./Marek_Ranger.jpg",
      link : "https://youtu.be/dQw4w9WgXcQ",
      text: "Toto som ja!",
      photo: "./Marek.jpg"
    },
    {
      id: 6,
      name: "Dominik Puk",
      role: "Patience Tester",
      picture:
        "./Dominik_Ranger.jpg",
      text: "Existuje asi iba 10 typov ľudí. Tí, ktorí rozumejú binárnej sústave a tí, ktorí nie.",
      photo: "./Dominik.jpg"
    },
    {
      id: 7,
      name: "Adam Valach",
      role: "Blockchain Overlord",
      picture:
        "./Adam_Ranger.jpg",
      text: "Blockchain nestačí iba pochopiť, treba ho čo najviac precíť.",
      photo: "./Adam.jpg"
    },
    {
      id: 8,
      name: "Samuel Vanek",
      role: "Dev God",
      picture:
        "./Samo_Ranger.jpg",
      text: "Môj kód veru nieje na kokód. *Niekedy sa ale pošťastí :)*",
      photo: "./Ja-samo.jpg"
    },
  ];
  return (
    <div id="team_members">
      <h1>Členovia tímu</h1>
      <div className="container">
        <div className="row">
          <div className="col justify-content-center d-flex" />
          <div className="col justify-content-center d-flex" >
            <Card
              name={items[0].name}
              role={items[0].role}
              text={items[0].text}
              picture={items[0].picture}
              photo={items[0].photo}
            />
          </div>
          <div className="col justify-content-center d-flex"  />
        </div>
        <div className="row">
          <div className="col justify-content-center d-flex">
            <Card
              name={items[1].name}
              role={items[1].role}
              text={items[1].text}
              picture={items[1].picture}
              photo={items[1].photo}
            />
          </div>
          <div className="col justify-content-center d-flex" >
            <Card
              name={items[2].name}
              role={items[2].role}
              text={items[2].text}
              picture={items[2].picture}
              photo={items[2].photo}
            />
          </div>
          <div className="col justify-content-center d-flex" >
            <Card
              name={items[3].name}
              role={items[3].role}
              text={items[3].text}
              picture={items[3].picture}
              link = {items[3].link}
              photo={items[3].photo}
            />
          </div>
        </div>
        <div className="row">
          <div className="col justify-content-center d-flex" >
            <Card
              name={items[4].name}
              role={items[4].role}
              text={items[4].text}
              picture={items[4].picture}
              photo={items[4].photo}
            />
          </div>
          <div className="col justify-content-center d-flex" >
            <Card
              name={items[5].name}
              role={items[5].role}
              text={items[5].text}
              picture={items[5].picture}
              photo={items[5].photo}
            />
          </div>
          <div className="col justify-content-center d-flex" >
            <Card
              name={items[6].name}
              role={items[6].role}
              text={items[6].text}
              picture={items[6].picture}
              photo={items[6].photo}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Team;
